export default "__VITE_ASSET__CawpiAht__"